import {Component, Input, OnInit} from '@angular/core';
import {ExgModalService} from 'exc-controls-v2';
import {ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'app-modal-library-info',
  templateUrl: './modal-library-info.component.html',
  styles: [
  ]
})
export class ModalLibraryInfoComponent  extends  ExcTranslation implements OnInit {

  @Input() data: any;
  constructor(private modalService: ExgModalService) {
    super();
  }

  ngOnInit(): void {
  }
  closeModal(): void {
    const _self = this;
    _self.modalService.close();
  }
  saveInfo(): void {
    const _self = this;
    _self.modalService.action({libComment: _self.data.libComment});
  }

  getHeader(): any {
    const _self = this;
    let header = '';
    if ( !this.data.isLibrary){header = _self.getRessource('EditInfo');
    }else {
        header = _self.getRessource('InfoHeader');
    }
    return header;
  }
}
